'use client'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  console.error('Global error:', error)

  return (
    <html>
      <body>
        <div style={{ padding: '40px', fontFamily: 'Arial, sans-serif' }}>
          <h1>Ошибка загрузки страницы</h1>
          <p>Сайт поймал ошибку на клиенте. Теперь её можно диагностировать.</p>

          <pre style={{ whiteSpace: 'pre-wrap', background: '#f5f5f5', padding: '20px' }}>
            {error?.message || 'Unknown error'}
          </pre>

          <button onClick={reset} style={{ padding: '10px 20px', marginTop: '20px' }}>
            Попробовать снова
          </button>
        </div>
      </body>
    </html>
  )
}
